<div mat-dialog-title class="d-flex justify-content-between align-items-center">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
   
    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
  
    <!-- <mat-chip-list
      style="display: flex; flex-wrap: wrap; width: 400px"
      aria-label="Fish selection"
      class="mb-2"
      *ngIf="!loader"
    >
      <mat-chip
        color="primary"
        selected
        *ngFor="let asset of assetList; let i = index"
        [removable]="removable"
        (removed)="removeAsset(i)"
        style="height: auto"
        >{{ asset?.assetName }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon></mat-chip
      >
    </mat-chip-list> -->
    <div *ngFor="let asset of assetList; let i = index" style="display: flex; justify-content: center;">
      <div class="image-preview" style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
        padding: 15px;
    ">
        <img [src]="asset.media_url" *ngIf="asset.asset_type == 1" alt="" style="width: 300px; height: 170px; object-fit: cover;">

        <video #videoElement  width="300" controls class="gallery_img_vid" *ngIf="asset.asset_type == 2">
          <source [src]="asset.media_url" type="video/mp4" />
      </video>

        <span (click)="removeAsset(i)" style="position: absolute;
        cursor: pointer;
        top: 0;
        right: 0;
        background: #dd2c00;
        border-radius: 50%;
        height: 30px;
        width: 30px;" ><mat-icon style="    position: absolute;
      left: 3px;
      top: 2px;
      color: white;" class="material-icons-outlined">close</mat-icon></span>
      </div>

    </div>
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          (change)="onUploadImage($event)"
        />
      </div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        assetList.length === 0
      "
      (click)="onPost()"
    >
      {{ editMode ? "Edit" : "Save" }}
    </button>
  </mat-dialog-actions>
  